import { render, staticRenderFns } from "./laobao.vue?vue&type=template&id=62eeb74e&scoped=true"
var script = {}
import style0 from "./laobao.vue?vue&type=style&index=0&id=62eeb74e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62eeb74e",
  null
  
)

export default component.exports